import { CalendarPrimitives } from 'venn-ui-kit';
import type moment from 'moment';
import React from 'react';

type ThirtyDayCalendarProps = {
  cells: moment.Moment[][];
  visibleMonth: moment.Moment;
  handlePreviousMonth: () => void;
  handleNextMonth: () => void;
  handleSelect: (date: moment.Moment) => void;
  isCellDisabled: (date: moment.Moment) => boolean;
  isNextMonthDisabled: boolean;
  isPreviousMonthDisabled: boolean;
  valueDate: moment.Moment;
};
export const ThirtyDayCalendar = ({
  cells,
  visibleMonth,
  handlePreviousMonth,
  handleNextMonth,
  handleSelect,
  isCellDisabled,
  isNextMonthDisabled,
  isPreviousMonthDisabled,
  valueDate,
}: ThirtyDayCalendarProps) => (
  <CalendarPrimitives.Root className="border-venn-grey-50">
    <CalendarPrimitives.Header className="[&&]:h-[15px] [&&]:mb-[3px] [&&]:mt-[9px]">
      <CalendarPrimitives.PreviousMonthButton
        disabled={isPreviousMonthDisabled}
        handlePreviousMonth={handlePreviousMonth}
        variant={{
          color: isPreviousMonthDisabled ? 'grey' : 'dark',
        }}
      />
      <CalendarPrimitives.CurrentMonth visibleMonth={visibleMonth} variant={{ color: 'dark' }} />
      <CalendarPrimitives.NextMonthButton
        disabled={isNextMonthDisabled}
        handleNextMonth={handleNextMonth}
        variant={{
          color: isNextMonthDisabled ? 'grey' : 'dark',
        }}
      />
    </CalendarPrimitives.Header>
    <CalendarPrimitives.DayRow variant={{ size: 'large', color: 'dark' }} />
    {cells.map((row: moment.Moment[], i: number) => (
      <CalendarPrimitives.Row key={row[0]?.valueOf() ?? `${String(i)}-row`}>
        {row.map((date) =>
          !inCurrentMonth(date, visibleMonth) ? (
            <CalendarPrimitives.EmptyCell key={date.valueOf()} />
          ) : (
            <CalendarPrimitives.Cell
              key={date.valueOf()}
              date={date}
              visibleMonth={visibleMonth}
              valueDate={valueDate}
              handleSelect={handleSelect}
              isDisabled={isCellDisabled}
              variant={{ color: 'dark', type: 'value' }}
            >
              {date.date()}
            </CalendarPrimitives.Cell>
          ),
        )}
      </CalendarPrimitives.Row>
    ))}
  </CalendarPrimitives.Root>
);

const inCurrentMonth = (date: moment.Moment, visibleMonth: moment.Moment) => {
  return date.month() === visibleMonth.month() && date.year() === visibleMonth.year();
};
